import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-product-nature.reducer';
import { IMetProductNature } from 'app/shared/model/met-product-nature.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetProductNature = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metProductNatureList = useAppSelector(state => state.metProductNature.entities);
  const loading = useAppSelector(state => state.metProductNature.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-product-nature-heading" data-cy="MetProductNatureHeading">
        <Translate contentKey="almobadaraMasterDataApp.metProductNature.home.title">Met Product Natures</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metProductNature.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metProductNature.home.createLabel">Create new Met Product Nature</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metProductNatureList && metProductNatureList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.status">Status</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProductNature.typeProductNature">Type Product Nature</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metProductNatureList.map((metProductNature, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metProductNature.id}`} color="link" size="sm">
                      {metProductNature.id}
                    </Button>
                  </td>
                  <td>{metProductNature.code}</td>
                  <td>{metProductNature.name}</td>
                  <td>{metProductNature.nameAr}</td>
                  <td>{metProductNature.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metProductNature.status}`} />
                  </td>
                  <td>
                    {metProductNature.typeProductNature ? (
                      <Link to={`cons-type-product-nature/${metProductNature.typeProductNature.id}`}>
                        {metProductNature.typeProductNature.name}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${metProductNature.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metProductNature.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metProductNature.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.home.notFound">No Met Product Natures found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetProductNature;
